import { render } from "./ListCreate.vue?vue&type=template&id=144d9902&scoped=true"
import script from "./ListCreate.vue?vue&type=script&lang=js"
export * from "./ListCreate.vue?vue&type=script&lang=js"

import "./ListCreate.vue?vue&type=style&index=0&id=144d9902&scoped=true&lang=css"

import exportComponent from "/usr/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-144d9902"]])

export default __exports__